import React from 'react';
import moment from 'moment'
class Deltalhes extends React.Component{
    constructor(props){
        super(props);
        this.state={

        }
    }
    render() {
        let{row}=this.props;
       console.log("rowwwww",row)
        return (
            <>
                <div className="mt-3">
                    <div className="my-3 ml-3">
                        <p className="k-mb-0"><strong>Nº de registo</strong></p>
                        <p className="k-mt-0">{row['Nr Registo'] || 'nd'}</p>
                    </div>
                    <div className="my-3 ml-3">
                        <p className="k-mb-0"><strong>Tipo de selo</strong></p>
                        <p className="k-mt-0">{row['tipoSelo'] || 'nd'}</p>
                    </div>
                    <div style={{marginRight:"30%"}} className="my-3  ml-3 d-flex k-justify-content-between">
                        <div>
                            <p className="k-mb-0"><strong>Data de aposição</strong></p>
                            <p className="k-mb-0">{moment(row['dataOperacao']).format('DD/MM/YY') || 'nd'}</p>
                        </div>
                        <div className="w-25">
                            <p className="k-mb-0"><strong>Data de engarrafamento</strong></p>
                            <p className="k-mb-0">{moment(row['dataEngarrafamento']).format('DD/MM/YY') || 'nd' }</p>
                        </div>
                    </div>
                    <div style={{marginRight:"30%"}} className="my-3  ml-3 d-flex k-justify-content-between">
                        <div>
                            <p className="k-mb-0"><strong>Nº Comunicação de Engarrafamento</strong></p>
                            <p className="k-mb-0">{row["numComunicacaoEngarr"] || "nd"}</p>
                        </div>
                        <div className="w-25">
                            <p className="k-mb-0"><strong>Lote</strong></p>
                            <p className="k-mb-0">{row["Lote"] || "nd"}</p>
                        </div>
                    </div>
                    <div className="my-3 ml-3">
                        <p className="k-mb-0"><strong>Capacidade garrafa (L)</strong></p>
                        <p className="k-mt-0">{row['capacidade'] || 'nd'}</p>
                    </div>
                    <div className="my-3 ml-3">
                        <p className="k-mb-0"><strong>Nº Lote</strong></p>
                        <p className="k-mt-0">{row['Lote'] || 'nd'}</p>
                    </div>

                    <div className="col-md-12 mt-3">
                        <p className="k-mb-0"><strong>Selos utilizados</strong></p>
                        <table className="w-100 text-center">
                            <thead className="border">
                                <tr className="d-flex justify-content-around py-2">
                                    <td><strong>Série</strong></td>
                                    <td><strong>De</strong></td>
                                    <td><strong>Até</strong></td>
                                    <td><strong>Perdas</strong></td>
                                </tr>
                            </thead>
                            <tbody className="border">
                                <tr className="d-flex justify-content-around py-2">
                                    <td className="w-25">{row['serie'] || 'nd'}</td>
                                    <td className="w-25">{row["perdaInicial"] || 'nd' }</td>
                                    <td className="w-25">{row["perdaFinal"] || 'nd' }</td>
                                    <td className="w-25">{row["perdas"] || 'nd' }</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="col-md-12 mt-3">
                        <p className="k-mb-0"><strong>Quantidades</strong></p>
                        <table className="w-100 text-center">
                            <thead className="border">
                                <tr className="d-flex justify-content-around py-2">
                                    <td className="w-25"><strong>Selos</strong></td>
                                    <td className="w-25"><strong>Litros</strong></td>
                                    <td className="w-25">{""}</td>
                                    <td className="w-25">{""}</td>
                                </tr>
                            </thead>
                            <tbody className="border">
                                <tr className="d-flex justify-content-around py-2">
                                    <td className="w-25">{row['nSelos'] || 'nd'}</td>
                                    <td className="w-25">{row["litros"] || 'nd' }</td>
                                    <td className="w-25">{""}</td>
                                    <td className="w-25">{""}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="col-md-12 mt-3">
                        <p className="k-mb-0"><strong>Selos inutilizados</strong></p>
                        <table className="w-100 text-center">
                            <thead className="border">
                                <tr className="d-flex justify-content-around py-2">
                                    <td className="w-25"><strong>Selos</strong></td>
                                    <td className="w-25"><strong>Litros</strong></td>
                                    <td className="w-25">{""}</td>
                                    <td className="w-25">{""}</td>
                                </tr>
                            </thead>
                            <tbody className="border">
                                <tr className="d-flex justify-content-around py-2">
                                    <td className="w-25">{row['nSelos'] || 'nd'}</td>
                                    <td className="w-25">{row["litros"] || 'nd' }</td>
                                    <td className="w-25">{""}</td>
                                    <td className="w-25">{""}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </>
        )
    }
}
export default Deltalhes;